<style>
.map-province {
  position: relative;
}
.express {
  position: absolute;
  right: 20px;
  top: 20px;
}
.express span {
  margin-left: 20px;
  color: #a0a0a0;
  font-size: 14px;
}
.express span::before {
  content: '';
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 4px;
}
.express span:first-child::before {
  background: #00a28a;
}
.express span:nth-child(2)::before {
  background: #333333;
}
.express span:nth-child(3)::before {
  background: #999999;
}
span.blue {
  color: #11a892;
}
span.black {
  color: #414141;
}
span.ash {
  color: #999999;
}
span.min-width {
  min-width: 80px;
  display: inline-block;
}
.cur {
  cursor: pointer;
}
</style>
<template>
  <div class="map-province m-t radius-5">
    <div
      class="font20 cur"
      @click="toDetail({code,name})"
      style="cursor:pointer;"
    >{{name?name:code}}</div>
    <div class="express">
      <span>合计</span>
      <span>本省卡</span>
      <span>外省卡</span>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="250"
      align="center"
    >
      <el-table-column fixed prop="all" label="合计/本省卡/外省卡"  :render-header="renderAll" width="200"></el-table-column>
      <el-table-column width="300" align="center" :render-header="renderHeader">
        <template slot-scope="scope">
          <span class="blue min-width">{{format(scope.row.time&&scope.row.time.all)}}</span>/
          <span class="black min-width">{{format(scope.row.time&&scope.row.time.in)}}</span>/
          <span class="ash min-width">{{format(scope.row.time&&scope.row.time.out)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" :render-header="renderHeaderYest">
        <template slot-scope="scope">
          <span class="blue min-width">{{format(scope.row.yest&&scope.row.yest.all)}}</span>/
          <span class="black min-width">{{format(scope.row.yest&&scope.row.yest.in)}}</span>/
          <span class="ash min-width">{{format(scope.row.yest&&scope.row.yest.out)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" :render-header="renderHeaderMonth">
        <!-- <template slot="header" slot-scope="scope">
            <h6>本月消费</h6>
        </template>-->
        <template slot-scope="scope">
          <span class="blue min-width">{{format(scope.row.month&&scope.row.month.all)}}</span>/
          <span class="black min-width">{{format(scope.row.month&&scope.row.month.in)}}</span>/
          <span class="ash min-width">{{format(scope.row.month&&scope.row.month.out)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" :render-header="renderHeaderSeason">
        <!-- <template slot="header" slot-scope="scope">
            <h6>本季度消费</h6>
        </template>-->
        <template slot-scope="scope">
          <span class="blue min-width">{{format(scope.row.season&&scope.row.season.all)}}</span>/
          <span class="black min-width">{{format(scope.row.season&&scope.row.season.in)}}</span>/
          <span class="ash min-width">{{format(scope.row.season&&scope.row.season.out)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" :render-header="renderHeaderYear">
        <!-- <template slot="header" slot-scope="scope">
            <h6>本年度消费</h6>
        </template>-->
        <template slot-scope="scope">
          <span class="blue min-width">{{format(scope.row.year&&scope.row.year.all)}}</span>/
          <span class="black min-width">{{format(scope.row.year&&scope.row.year.in)}}</span>/
          <span class="ash min-width">{{format(scope.row.year&&scope.row.year.out)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="300" align="center" :render-header="renderHeaderHist">
        <!-- <template slot="header" slot-scope="scope">
            <h6>历史累计消费</h6>
        </template>-->
        <template slot-scope="scope">
          <span class="blue min-width">{{format(scope.row.hist&&scope.row.hist.all)}}</span>/
          <span class="black min-width">{{format(scope.row.hist&&scope.row.hist.in)}}</span>/
          <span class="ash min-width">{{format(scope.row.hist&&scope.row.hist.out)}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    allData: {
      type: [Object, Array]
    },
    name: {
      default: '合计',
      type: String
    },
    code: {
      default: '',
      type: String
    },
    toDetail: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
      tableData: [...this.allData],
      // loading: true
    }
  },
  watch: {
    allData: function(value, oldValue) {
      if (value.length) {
        this.tableData = [...this.allData]
        // this.loading=false
      }
    }
  },
  mounted() {
    // if(this.allData){
    //     this.tableData = this.initData(this.allData);
    // }
  },
  methods: {
    format(num) {
      if(num==null) return 0;
        var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                return $1+",";
                });
        })
        return res;
    },
    renderAll(h, { column }) {
      return h(
        'div',
        {
          style:
            'line-height:1.2;padding-top:5px;font-size:16px;font-weight:400;'
        },
        [
          h('span', { style: 'color:#11A892' }, '合计'),
          h('span', '/'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
          h('span', { style: 'color:#414141;' }, '本省卡'),
          h('span', '/'),
          h('span', { style: 'color:#999999;' }, '外省卡')
        ]
      )
    },
    renderHeader(h, { column }) {
      if (
        this.tableData[0] &&
        this.tableData[0].time &&
        this.tableData[0].time.section
      ) {
        return h(
          'div',
          { style: 'line-height:1.2;text-align:center;padding-top:5px;' },
          [
            h(
              'span',
              { style: 'font-size:16px;line-height:0;color:#4E4E4E' },
              '指定时间消费'
            ),
            h('br'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
            h(
              'span',
              { style: 'color:#A6A6A6;font-size:14px;font-weight:400;' },
              this.tableData[0].time.section
            )
          ]
        )
      }
    },
    renderHeaderYest(h, { column }) {
      if (
        this.tableData[0] &&
        this.tableData[0].yest &&
        this.tableData[0].yest.section
      ) {
        return h(
          'div',
          { style: 'line-height:1.2;text-align:center;padding-top:5px;' },
          [
            h(
              'span',
              { style: 'font-size:16px;line-height:0;color:#4E4E4E' },
              '昨日消费'
            ),
            h('br'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
            h(
              'span',
              { style: 'color:#A6A6A6;font-size:14px;font-weight:400;' },
              this.tableData[0].yest.section
            )
          ]
        )
      }
    },
    renderHeaderMonth(h, { column }) {
      if (
        this.tableData[0] &&
        this.tableData[0].month &&
        this.tableData[0].month.section
      ) {
        return h(
          'div',
          { style: 'line-height:1.2;text-align:center;padding-top:5px;' },
          [
            h(
              'span',
              { style: 'font-size:16px;line-height:0;color:#4E4E4E' },
              '本月消费'
            ),
            h('br'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
            h(
              'span',
              { style: 'color:#A6A6A6;font-size:14px;font-weight:400;' },
              this.tableData[0].month.section
            )
          ]
        )
      }
    },
    renderHeaderSeason(h, { column }) {
      if (
        this.tableData[0] &&
        this.tableData[0].season &&
        this.tableData[0].season.section
      ) {
        return h(
          'div',
          { style: 'line-height:1.2;text-align:center;padding-top:5px;' },
          [
            h(
              'span',
              { style: 'font-size:16px;line-height:0;color:#4E4E4E' },
              '本季度消费'
            ),
            h('br'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
            h(
              'span',
              { style: 'color:#A6A6A6;font-size:14px;font-weight:400;' },
              this.tableData[0].season.section
            )
          ]
        )
      }
    },
    renderHeaderYear(h, { column }) {
      if (
        this.tableData[0] &&
        this.tableData[0].year &&
        this.tableData[0].year.section
      ) {
        return h(
          'div',
          { style: 'line-height:1.2;text-align:center;padding-top:5px;' },
          [
            h(
              'span',
              { style: 'font-size:16px;line-height:0;color:#4E4E4E' },
              '本年度消费'
            ),
            h('br'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
            h(
              'span',
              { style: 'color:#A6A6A6;font-size:14px;font-weight:400;' },
              this.tableData[0].year.section
            )
          ]
        )
      }
    },
    renderHeaderHist(h, { column }) {
      if (
        this.tableData[0] &&
        this.tableData[0].hist &&
        this.tableData[0].hist.section
      ) {
        return h(
          'div',
          { style: 'line-height:1.2;text-align:center;padding-top:5px;' },
          [
            h(
              'span',
              { style: 'font-size:16px;line-height:0;color:#4E4E4E' },
              '历史累计消费'
            ),
            h('br'), //第一个参数是标签名称 第二个参数 属性 第三个参数标签内容
            h(
              'span',
              { style: 'color:#A6A6A6;font-size:14px;font-weight:400;' },
              this.tableData[0].hist.section
            )
          ]
        )
      }
    }
  }
}
</script>